export const binDocs = {
  name: 'bin',
  category: 'Utils',
  syntax: [
    'bin(value)'
  ],
  description: 'Format a number as binary',
  examples: [
    'bin(2)'
  ],
  seealso: ['oct', 'hex']
}
